// src/config.js
const WORKER_URL = 'https://golf-store-api.jcllamas1234.workers.dev';

export const API_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:8787/api'  // For local development
  : `${WORKER_URL}/api`;

export default API_URL;